import { compareNodes } from '@graphql-tools/utils';
export function mergeArguments(args1, args2, config) {
    var result = deduplicateArguments([].concat(args2, args1).filter(function (a) { return a; }));
    if (config && config.sort) {
        result.sort(compareNodes);
    }
    return result;
}
function deduplicateArguments(args) {
    return args.reduce(function (acc, current) {
        var dup = acc.find(function (arg) { return arg.name.value === current.name.value; });
        if (!dup) {
            return acc.concat([current]);
        }
        return acc;
    }, []);
}
//# sourceMappingURL=arguments.js.map